import React from 'react';
import Disclaimer from './Disclaimer';
import ConsultationHeader from './ConsultationHeader';
import ConsultationInfo from './ConsultationInfo';

const ConsultationCard = ({
  consultation,
  hideDisclaimer,
  onHideDisclaimer,
  goBack,
  user,
  onSponsorClick,
  sponsor,
  setStatistic,
  handleCopy,
}) => (
  <section className="sec-consult-main">
    <div className="container">
      <ConsultationHeader
        consultation={ consultation }
        goBack={ goBack }
        user={ user }
        onSponsorClick={ onSponsorClick }
        sponsor={ sponsor }
        setStatistic={ setStatistic }
        handleCopy={ handleCopy }
      />
      <div className="consult-container-editor">
        <div className="container-small">
          { !hideDisclaimer &&
            <Disclaimer
              disclaimer={ consultation.disclaimer }
              onHideDisclaimer={ onHideDisclaimer }
            />
          }
          <ConsultationInfo
            title={ consultation.title }
            consultation={ consultation }
            user={ user }
            onSponsorClick={ onSponsorClick }
            attachmentName=''
            sponsor={ sponsor }
            setStatistic={ setStatistic }
          />
          <ConsultationInfo
            name={ 'History' }
            description={ consultation.history }
            className='history'
            attachments={ consultation.attachments }
            attachmentName='history'
          />
          <ConsultationInfo
            name={ 'Exam' }
            description={ consultation.exam }
            className='exam'
            attachments={ consultation.attachments }
            attachmentName='exam'
          />
          <ConsultationInfo
            name={ 'impression' }
            description={ consultation.impresion }
            className='impression'
            attachments={ consultation.attachments }
            attachmentName='impression'
          />
          <ConsultationInfo
            name={ 'plan' }
            description={ consultation.plan }
            className='plan'
            attachments={ consultation.attachments }
            attachmentName='plan'
          />
          <ConsultationInfo
            name={ 'additional info' }
            description={ consultation.aditional_info }
            className='additional'
            attachments={ consultation.attachments }
            attachmentName='aditional_info'
          />
        </div>
      </div>
    </div>
  </section>
);

export default ConsultationCard;